import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { ErrorDefinition } from '../../models/error-definition';
import { MaskConfig } from '../../../utility/mask-config';
import { MaskUtility } from '../../../utility/mask-utility';
import { NgxMaskDirective } from 'ngx-mask'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports:[
    ReactiveFormsModule,
    NgxMaskDirective, FormsModule, CommonModule, MatIconModule,
    MatInputModule,
  ],
})
export class PhoneInputComponent extends BaseInputDirective implements OnInit, OnChanges {
  phoneMaskConfig: MaskConfig;
  @Input() useUsMask: boolean = true;
  @Input() usePlaceholderAsHint: boolean = true;
  @Output() richChange = new EventEmitter();
  hasMask: boolean = true;

  
 



  ngOnInit() {
    super.ngOnInit();

    if (this.useUsMask) {
      this.setUsaMask();
    } else {
      this.setInternationalMask();
    }
  }

  getErrorDefinitions(): ErrorDefinition[] {
    const errors = super.getErrorDefinitions() || [];
    errors.push(
      this.errorService.createErrorDefinition(this.formControl, 'mask', 'Invalid Phone Number'),
    );
    return errors;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['useUsMask'] && !changes['useUsMask'].firstChange) {
      if (this.useUsMask) {
        this.setUsaMask();
      } else {
        this.setInternationalMask();
      }
    }
  }

  private setUsaMask() {
    this.phoneMaskConfig = MaskUtility.getUsPhoneNumberMask();
  }

  private setInternationalMask() {
    this.formControl.setValue(this.formControl.value);
    this.phoneMaskConfig = MaskUtility.getNonUsPhoneNumberMask();
  }
}
